import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'


const OnlineExaminationSoftware = () => {
    //const loc = location ? `in ${location}` : '';

    //const pageTitle = `Best Online Examination Software ${loc} | ERP Systems | Business Management Solutions - Tejaxo Software`;
    //const metaDescription = `Tejaxo Software is a High Rated Indian Online Examination Software ${loc}, providing award-winning Enterprise Resource Planning (ERP) software for Online Examination, business management solutions, services and support.`;
    //const metaKeywords = `Tejaxo Online Examination Software ${loc}, Tejaxo Online Examination System Software`;

    //React.useEffect(() => {
    //    document.title = pageTitle;
    //    const metaDescTag = document.querySelector('meta[name="description"]');
    //    const metaKeyTag = document.querySelector('meta[name="keywords"]');

    //    if (metaDescTag) metaDescTag.content = metaDescription;
    //    if (metaKeyTag) metaKeyTag.content = metaKeywords;
    //}, [pageTitle, metaDescription, metaKeywords]);

    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
        <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
            <div className="container">
                <div className="row">
                        <h2 className="mkdf-page-title entry-title">
                            Online Examination Software {state.condText}
                    </h2>
                </div>
                <br />
                <div className="row">
                    <h3 className="mkdf-page-title entry-title">
                        Best Features Of Examination Creating Software?
                    </h3>
                    <div className="darkhome">
                        <p>
                            There are lots of features available in software like 1. Whitelabel with Branding, 2. Take Live Classes, 3. Quick Result Generate, 4. Coupon Generate Facility, 5. SMS Integration and lots more. Learn from below.
                        </p>
                        <p>
                            <strong>Easy Question Upload</strong>: This online examination system is compatible with AI that�s why Tejaxo software enables you to upload questions/items in any language.
                        </p>
                    </div>
                    <div className="darkhome">
                        <p>
                            <strong>Best Supportive Team</strong>: An experienced team of Tejaxo provides 24x7 support to ensure that all the examination-related queries and issues get resolved quickly. It generates detailed results quickly as soon as the exam gets completed.
                        </p>
                    </div>
                    <div className="darkhome">
                        <p>
                            <strong>Integrate SMS</strong>: The feature of integrated SMS ensures that the test takers are aware of all the necessary exam-related notifications. With its responsive feature, you can evaluate your students on any screen (computer or mobile).
                        </p>
                    </div>
                    <div className="darkhome">
                        <p>
                            <strong>Cities Covered in India:</strong> Delhi, Maharashtra, Uttar Pradesh, Gujarat, West Bengal, Madhya Pradesh, Kerala, Andhra Pradesh, and more.
                        </p>
                    </div>
                </div>
                <br />
                <div className="row">
                    <h3 className="mkdf-page-title entry-title">
                        Importance of Online Examination System in Tejaxo?
                    </h3>
                    <p>
                        Technological inventions often offer innumerable benefits, and almost all service sectors nowadays are equipped with tech-savvy products. The advantages offered by these discoveries have made it necessary for educational institutions to include online examination software for evaluating learners� capabilities.
                    </p>
                    <p>
                        <strong>Education Software reduces exams burdens, Taking exam anywhere:</strong> Online exams reduce the administrative burden of the exam holding bodies as this software generates detailed results instantly. Computer-based exams lessen the exam anxiety and promote mental health. Students can take the exam anywhere conveniently.
                    </p>
                    <p>
                        <strong>Improve Communication Gap Between Teachers and Students:</strong> With instant detailed results, teachers can provide accurate feedback to the students and suggest ways for improving performance. Elimination of administrative burden, any proctoring, and automatic onscreen checking helps to save examination costs.
                    </p>
                </div>
                <br />
                <div className="row">
                    <h3 className="wow rubberBand" style={{ visibility: 'visible', animationName: 'rubberBand' }}>
                        What Tejaxo Thinks for Students and Teachers
                    </h3>
                    <p>
                        We have incorporated features in this online examination software keeping in mind the requirements of both students and teachers. Learners can take their exams anytime, anywhere, and teachers can provide accurate feedback. It reduces stress and improves performance.
                    </p>
                    <p>
                        Other software providers often charge more, but Tejaxo online test software is available at a moderate price with a free demo. Our primary clientele includes KD Campus, Goal Institute, Gate Academy, Career Endeavour, Pinnacle, Chanakya, and more.
                    </p>
                </div>
            </div>
            </section>
        </MasterPage>
    );
};

export default OnlineExaminationSoftware;